export default async function(selected) {
     const googleClass = await GoogleMapsLoader.getMap();
     if(selected == true){
        return {
            url: '/images/redesign/map/map-pin-selected.svg',
            scaledSize: new googleClass.maps.Size(28, 34),
            anchor: new googleClass.maps.Point(14, 34), 
        };
    }else{
        return {
            url: '/images/redesign/map/map-pin.svg',
            scaledSize: new googleClass.maps.Size(28, 34),
            anchor: new googleClass.maps.Point(14, 34), 
        };
    }
}